import React                from "react"
import { ExtraFieldAnswer } from "./extraFieldAnswer"

export const ExtraFields = ({ workorderState, setWorkorderState }) => {
  const handleInputChange = (value, fieldAnswer) => {
    setWorkorderState({ 
      extraFieldAnswers: workorderState.extraFieldAnswers.map(answer => 
        answer.extraFieldId != fieldAnswer.extraFieldId ? answer : { ...answer, [`${fieldAnswer.answerType}Answer`]: value } 
      ) 
    })
  }

  return(
    <div>
      { workorderState.extraFieldAnswers.map(answer => {
          return <ExtraFieldAnswer
            key       = { answer.extraFieldId } 
            workorder = { workorderState }
            answer    = { answer } 
            onChange  = { handleInputChange } 
          />
        })
      }
    </div>
  )
}
